import DefaultElementNodeType from '../DefaultElementNodeType';
import {TECHNOLOGY_SERVICE} from '../../metamodel/Concept';

export default class TechnologyServiceNodeType extends DefaultElementNodeType {
	static get typeName() {
		return TECHNOLOGY_SERVICE;
	}
}
